import React from "react";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";

const checklist = `Pre-sailing Weather Checklist\n\n1. Check average wind speed and gust spread.\n2. Compare wave height with your boat size and crew comfort.\n3. Review swell period and direction.\n4. Check visibility, rain and cloud development.\n5. Check tide timing for departure and arrival.\n6. Review air pressure trend and storm signals.\n7. Confirm marina, fuel and safe shelter options.\n8. Re-check official marine forecasts before departure.\n9. Brief the crew on go/no-go limits.\n10. Keep monitoring weather while underway.\n`;

export default function WeatherChecklistDownload() {
  const href = `data:text/plain;charset=utf-8,${encodeURIComponent(checklist)}`;
  return (
    <div className="rounded-3xl border border-primary/20 bg-primary/10 p-5">
      <p className="text-sm font-black uppercase tracking-[0.2em] text-primary">Download</p>
      <h3 className="mt-2 text-xl font-black">Pre-sailing weather checklist</h3>
      <p className="mt-2 text-sm leading-7 text-muted-foreground">A simple printable checklist for wind, waves, tide, visibility and safe shelter checks.</p>
      <Button asChild className="mt-4 w-full" size="sm">
        <a href={href} download="pre-sailing-weather-checklist.txt"><Download className="h-4 w-4" /> Download checklist</a>
      </Button>
    </div>
  );
}